import ProductIndex from "../views/Colleges/ProductIndex.vue";
import Index from "../views/Colleges/index.vue";
import Autnent from "@/zh-website/src/views/Enterprise/Autnent.vue";
import Profession from "@/zh-website/src/views/Colleges/profession/index.vue";
import Case from "@/zh-website/src/views/Colleges/Case.vue";
import Education from "@/zh-website/src/views/Colleges/Education.vue";
import EducationDetails from "@/zh-website/src/views/Colleges/Education/Details.vue";
export const CollegesRoute = {
  path: "/colleges",
  name: "Colleges",
  component: Index,
  meta: { type: 4, title: "高校用户-浙江华为门户网站", serial: 1 },
  redirect: "/colleges/page",
  children: [
    {
      path: "/colleges/page",
      name: "College",
      component: ProductIndex,
      meta: {
        type: 4,
        title: "高校用户-浙江华为门户网站",
        serial: 1
      }
    },
    {
      path: "/colleges/authent/:id",
      name: "authent",
      component: Autnent,
      meta: {
        type: 4,
        title: "华为认证-浙江华为门户网站",
        serial: 4
      }
    },
    {
      path: "/colleges/solve/profession/:id",
      name: "Profession",
      component: Profession,
      meta: {
        type: 4,
        title: "专业-浙江华为门户网站",
        serial: 1
      }
    },
    {
      path: "/colleges/caseDetail/:type",
      name: "Solve",
      component: Case,
      meta: {
        type: 4,
        title: "院校案例-浙江华为门户网站",
        serial: 2
      }
    },
    {
      path: "/colleges/teach/:type",
      name: "Solve",
      component: Education,
      meta: {
        type: 4,
        title: "教育合作-浙江华为门户网站",
        serial: 3
      }
    },
    {
      path: "/colleges/details/:id/:aid",
      name: "educationDetails",
      component: EducationDetails,
      meta: {
        type: 4,
        title: "教育合作-浙江华为门户网站",
        serial: 3
      }
    }
  ]
};
